import React from "react"

export function displayPhone(p) {
  const pArray = p.split('-')
  return `(${pArray[0]}) ${pArray[1]}-${pArray[2]}`
}

export function generateUrl (clinic, slug) {
  if (clinic) return `/${clinic.url}/${slug}`

  return `/${slug}`
}

export function generateAddress(clinic, includeBreaks = true, includeIcon = false) {
  return <div 
    onClick={() => {
      if (clinic.googleMapsUrl) {
        window.open(clinic.googleMapsUrl, '_blank');
      }
    }}
    className={`${ clinic.googleMapsUrl ? 'cursor-pointer' : ''}`}
  >
    {clinic.street1}{includeBreaks ? <br/> : clinic.street2 ? ' ' : ', '} 
    {clinic.street2 && <React.Fragment>{clinic.street2}{includeBreaks ? <br/> : ', '}</React.Fragment>} 
    {clinic.city} WA, {clinic.zip} 
    {
      includeIcon &&
      <span className="material-symbols-rounded text-sm ml-1">
        directions
      </span>
    }

  </div>
}

export function generatePhone(p, includeIcon = false) {
  return <React.Fragment>
    <a href={`tel: ${p}`}>{displayPhone(p)}</a>
    {
      includeIcon &&
      <span className="material-symbols-rounded text-sm ml-1">
        call
      </span>
    }
  </React.Fragment>
}

export function generateFax(f, includeIcon = false) {
  return <React.Fragment>
    {displayPhone(f)}
    {
      includeIcon &&
      <span className="material-symbols-rounded text-sm ml-1">
        fax
      </span>
    }
  </React.Fragment>
}